var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelSecondaryIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2293",
    "data-name": "Group 2293",
    transform: "translate(-16 -88)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 24,
    height: 24,
    transform: "translate(16 88)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "x_4_",
    "data-name": "x (4)",
    transform: "translate(16 88)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    x1: 12,
    y2: 12,
    transform: "translate(6 6)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x2: 12,
    y2: 12,
    transform: "translate(6 6)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSecondaryIcon);
export default __webpack_public_path__ + "static/media/cancel-secondary-icon.43acf942131e64507d6c4f339667fe01.svg";
export { ForwardRef as ReactComponent };